function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 76C59.8823 76 76 59.8823 76 40C76 20.1177 59.8823 4 40 4C20.1177 4 4 20.1177 4 40C4 59.8823 20.1177 76 40 76Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 60.9531C51.6498 60.9531 61.0938 51.5091 61.0938 39.8594C61.0938 28.2096 51.6498 18.7656 40 18.7656C28.3502 18.7656 18.9062 28.2096 18.9062 39.8594C18.9062 51.5091 28.3502 60.9531 40 60.9531Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.75 33.25H35.25C34.1454 33.25 33.25 34.1454 33.25 35.25V44.75C33.25 45.8546 34.1454 46.75 35.25 46.75H44.75C45.8546 46.75 46.75 45.8546 46.75 44.75V35.25C46.75 34.1454 45.8546 33.25 44.75 33.25Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 40,
  y1: 4,
  x2: 40,
  y2: 76,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2E66F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#134BDC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 40,
  y1: 33.25,
  x2: 40,
  y2: 46.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#225AEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1E56E8"
})));

var SvgCoinbase = function SvgCoinbase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinbase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinbase.0c0e597a.svg";
export { ForwardRef as ReactComponent };